module.exports = __webpack_public_path__ + "img/bayes-formula.342727e8.png";